<template>
    <div class="p-grid">
		<div class="p-col-12">
			<div class="card p-shadow-1">
				<h5>Clientes IKAcesso</h5>
				<hr>

				<Toolbar class="p-mb-4">
					<template slot="left">
						<Button type="button" icon="pi pi-plus" label="Novo" class="p-mr-2" @click="novo" />
					</template>
				</Toolbar>

				<DataTable :value="contas" class="p-datatable-sm p-datatable-striped">
					<template #header>
						<div class="table-header">
							<div class="p-d-flex p-jc-end">
								<InputText v-model="valorBusca" placeholder="Razão Social / Documento" @keyup.enter="buscar" style="width: 100%;" />
								<Button label="Buscar" icon="pi pi-search" class="p-ml-2" @click="buscar" />
							</div>
						</div>
					</template>
					<Column field="cliente.documento" header="Documento">
						<template #body="slotProps">
							<span v-if="slotProps.data.cliente.tipoDocumento === 'cnpj'">{{ slotProps.data.cliente.documento | maskCNPJ }}</span>
							<span v-else>{{ slotProps.data.cliente.documento | maskCPF }}</span>
						</template>
					</Column>
					<Column field="cliente.razaoSocial" header="Razão Social / Nome"></Column>
					<Column field="cliente.segmento" header="Segmento"></Column>
					<Column field="dataContrato" header="Data Contrato">
						<template #body="slotProps">
							{{ slotProps.data.dataContrato | datePtBR }}
						</template>
					</Column>
                    <Column field="modoOperacao" header="Modo de Operação">
						<template #body="slotProps">
							{{ descricaoModoOperacao(slotProps.data.modoOperacao) }}
						</template>
					</Column>
					<Column field="status" header="Status"></Column>
					<Column header="">
						<template #body="slotProps">
							<Button icon="pi pi-pencil" title="Editar" class="p-button-rounded p-button-primary p-mr-2" @click="editar(slotProps.data)" />
                            <Button icon="pi pi-file-o" title="Logs" class="p-button-rounded p-button-primary" @click="verLogs(slotProps.data)" />
						</template>
					</Column>
				</DataTable>

				<Paginator :rows="totalPorPagina" :totalRecords="totalItens" :rowsPerPageOptions="[15, 25, 30]"
					template="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
					currentPageReportTemplate="Listando {first} de {last} de {totalRecords}"
					@page="paginar($event)" />
            </div>
        </div>
    </div>
</template>

<script>
import ClienteIKAcessoService from '@/service/ClienteIKAcessoService';
import { exibirMensagem } from '@/global';

export default {
    data() {
        return {
            contas: [],
            totalItens: 0,
            totalPorPagina: 15,
            pagina: 0,
            valorBusca: ''
        }
    },
    methods: {
        paginar(event) {
            this.pagina = event.page;
            this.totalPorPagina = event.rows;
            this.listar();
        },
        buscar() {
            this.pagina = 0;
            this.totalItens = 0;
            this.listar();
        },
        listar() {
            this.clienteService.listarContas(this.valorBusca, this.pagina, this.totalPorPagina)
                .then(resp => {
                    this.totalItens = resp.data.totalItens;
                    this.contas = resp.data.contas;
                })
                .catch(erro => { exibirMensagem(this, erro) });
        },
        verLogs(conta) {
            this.$router.push('/cadastro/clientes/ikacesso/logs-operadores-operacoes/' + conta.id + '/logs');
        },
        novo() {
            this.$router.push('/cadastro/clientes/ikacesso/novo');
        },
        editar(conta) {
            // Busca o cliente com o id da conta para obter os dados necessários para edição (endereço, plano atual, etc)
            this.$router.push('/cadastro/clientes/ikacesso/' + conta.id + '/' + conta.cliente.id + '/editar');
        },
        descricaoModoOperacao(modo) {
            if (modo === 'OFFLINE') return 'Modo Offline';
            if (modo === 'ONLINE') return 'Modo Online';
            return '';
        },
    },
    created() {
        this.clienteService = new ClienteIKAcessoService();
    },
    mounted() {
        this.listar();
    }
}
</script>

<style>
</style>